<template>
  <div
    class="volume-box"
    :class="{
      'volume-box__h5': isH5,
      'volume-box__h5-landscape': isLandscape,
    }"
  >
    <img :src="volumeIcon" alt="" @click="toggleMute" />
    <div class="volume-control" v-if="isShow">
      <!-- 可选：展示当前音量值 -->
      <span class="volume-label">{{ volume }}%</span>
      <div class="volume-slider-box">
        <div
          class="progress"
          :style="{
            width: `${volumePercentage >= 100 ? 100 : volumePercentage}%`,
          }"
        ></div>
        <input
          type="range"
          min="0"
          :max="100"
          v-model.number="volume"
          @input="onVolumeChange"
          class="volume-slider"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    // 音量最大百分比 100：100%， 1000，1000%
    maxVolume: {
      type: Number,
      default: 100,
    },
    isLandscape: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      volume: 0, // 初始音量值
      isShow: false,
      volumeIconNo: require("../../../../../assets/images/reply/volume_no.png"),
      volumeIconMedium: require("../../../../../assets/images/reply/volume_medium.png"),
      volumeIconMin: require("../../../../../assets/images/reply/volume_min.png"),
      volumeIconMax: require("../../../../../assets/images/reply/volume_max.png"),
      isH5: isH5(),
    };
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.volume = newValue.toFixed(0);
        } else {
          this.volume = 0;
        }
      },
      immediate: true, // 初始化时同步设置 volume
    },
  },
  mounted() {
    // 监听页面点击其他地方关闭音量控制
    document.addEventListener("click", this.clickOutside);
    // 监听滚轮音量控制
    document.addEventListener("wheel", this.handleVolumeChange);
  },
  beforeDestroy() {
    // 移除页面点击事件监听
    document.removeEventListener("click", this.clickOutside);
    document.removeEventListener("wheel", this.handleVolumeChange);
  },
  computed: {
    volumePercentage() {
      return (this.volume / 100) * 100 || 0;
    },
    volumeIcon() {
      if (this.volumePercentage === 0) {
        return this.volumeIconNo;
      } else if (this.volume > 0 && this.volume < 30) {
        return this.volumeIconMin;
      } else if (this.volume >= 30 && this.volume < 70) {
        return this.volumeIconMedium;
      } else {
        return this.volumeIconMax;
      }
    },
  },
  methods: {
    handleVolumeChange(e) {
      if (!this.isShow) {
        return;
      }
      // 判断上下滚动
      if (e.deltaY === 0) {
        return;
      }
      const step = this.maxVolume / 100;
      if (e.deltaY < 0) {
        if (this.volume >= this.maxVolume) {
          this.volume = this.maxVolume;
          return;
        }
        this.volume = +this.volume + step;
      } else {
        if (this.volume <= 0) {
          this.volume = 0;
          return;
        }
        this.volume = +this.volume - step;
      }
      this.$emit("change", this.volume);
      this.$emit("input", this.volume);
    },
    // 监听页面点击事件
    clickOutside(event) {
      const target = event.target;
      if (!this.$el.contains(target)) {
        this.isShow = false;
      }
    },
    onVolumeChange(event) {
      this.volume = event.target.value;
      console.log("音量的大小》〉》〉》〉", this.volume);
      this.$emit("change", this.volume);
      this.$emit("input", this.volume);
      // 在这里处理音量变化事件，例如更新音量设置
    },
    toggleMute() {
      this.isShow = !this.isShow;
    },
    // 判断是否手机端并且横屏
    // isLandscape() {
    //   if (isMobile()) {
    //     return window.innerWidth > window.innerHeight;
    //   } else {
    //     return false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
input {
  outline: none;
}
.volume-box {
  position: relative;
  img {
    width: 30px;
    cursor: pointer;
  }
  .volume-control {
    position: absolute;
    top: -248px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 60px;
    height: 200px;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 16px;
    padding: 12px 0;
    .volume-label {
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
    }

    .volume-slider-box {
      position: relative;
      width: 150px;
      height: 6px;
      background: rgba(217, 217, 217, 0.4);
      border-radius: 3px;
      transform: rotate(270deg) translate(-75px, 0);
      .progress {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #00c89d;
        border-radius: 3px;
      }
      .volume-slider {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 0;
        cursor: pointer; /* 使滑块指示器看起来像可点击的 */
        appearance: none; /* 移除默认样式 */
        -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      }
      .volume-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 15px;
        height: 15px;
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      .volume-slider:hover::-webkit-slider-thumb {
        width: 24px;
        height: 24px;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }

      .volume-slider:active::-webkit-slider-thumb {
        width: 24px;
        height: 24px;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }
    }
  }
}
.volume-box__h5 {
  position: relative;
  img {
    width: 0.5333rem;
    cursor: pointer;
  }
  .volume-control {
    position: absolute;
    top: -3.1rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 1.0667rem;
    height: 2.8rem;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 0.1rem;
    padding: 0.075rem 0;
    .volume-label {
      font-size: 0.4rem;
      color: #ffffff;
      line-height: 0.5333rem;
    }
    .volume-slider-box {
      position: relative;
      width: 1.8rem;
      height: 0.1333rem;
      background: rgba(217, 217, 217, 0.4);
      border-radius: 3px;
      transform: rotate(270deg) translate(-1rem, 0);
      .progress {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #00c89d;
        border-radius: 3px;
      }
      .volume-slider {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 0;
        cursor: pointer; /* 使滑块指示器看起来像可点击的 */
        appearance: none; /* 移除默认样式 */
        -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      }
      .volume-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 0.2667rem;
        height: 0.2667rem;
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      .volume-slider:hover::-webkit-slider-thumb {
        width: 0.32rem;
        height: 0.32rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }

      .volume-slider:active::-webkit-slider-thumb {
        width: 0.32rem;
        height: 0.32rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }
    }
  }
}
.volume-box__h5-landscape {
  position: relative;
  img {
    width: 0.25rem;
    cursor: pointer;
  }
  .volume-control {
    position: absolute;
    top: -2.4rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 0.5625rem;
    height: 1.7rem;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 0.1rem;
    padding: 0.075rem 0;
    .volume-label {
      font-size: 0.175rem;
      color: #ffffff;
      line-height: 0.1875rem;
    }

    .volume-slider-box {
      position: relative;
      width: 1.125rem;
      height: 0.075rem;
      background: rgba(217, 217, 217, 0.4);
      border-radius: 3px;
      transform: rotate(270deg) translate(-0.5625rem, 0);
      .progress {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #00c89d;
        border-radius: 3px;
      }
      .volume-slider {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 0;
        cursor: pointer; /* 使滑块指示器看起来像可点击的 */
        appearance: none; /* 移除默认样式 */
        -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      }
      .volume-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 0.1563rem;
        height: 0.1563rem;
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      .volume-slider:hover::-webkit-slider-thumb {
        width: 0.15rem;
        height: 0.15rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }

      .volume-slider:active::-webkit-slider-thumb {
        width: 0.15rem;
        height: 0.15rem;
        background-color: #fff;
        border: 5px solid rgba(0, 200, 157, 0.5);
      }
    }
  }
}
</style>
